/**
 * 电视机大屏：轮询 version.json，发现新发版后自动 reload。
 * 无需人工强刷；依赖发布时写入 dist/version.json，且 index.html / version.json 短缓存。
 */
const POLL_MS = 3 * 60 * 1000
const SAFETY_RELOAD_MS = 6 * 60 * 60 * 1000 // 最长 6 小时兜底整页刷新一次

function readEmbeddedBuildId() {
  return String(process.env.VUE_APP_BUILD_ID || '').trim()
}

function fetchRemoteBuildId() {
  const url = `${process.env.BASE_URL || '/'}version.json?t=${Date.now()}`
  return fetch(url, { cache: 'no-store', credentials: 'omit' })
    .then((res) => {
      if (!res.ok) throw new Error('version http ' + res.status)
      return res.json()
    })
    .then((data) => String((data && (data.buildId || data.build_id)) || '').trim())
}

function reloadForUpdate(reason) {
  // eslint-disable-next-line no-console
  console.info('[tvAutoUpdate] reload:', reason)
  // 带时间戳，尽量绕过中间层对 document 的缓存
  const u = new URL(window.location.href)
  u.searchParams.set('_tv', String(Date.now()))
  window.location.replace(u.toString())
}

export function startTvAutoUpdate() {
  if (typeof window === 'undefined' || typeof fetch !== 'function') return
  const embedded = readEmbeddedBuildId()
  if (!embedded) {
    // 本地 dev 无 BUILD_ID：只做超长兜底，避免干扰开发
    setTimeout(() => reloadForUpdate('safety-no-build-id'), SAFETY_RELOAD_MS)
    return
  }

  let checking = false
  const check = () => {
    if (checking) return
    checking = true
    fetchRemoteBuildId()
      .then((remote) => {
        if (remote && remote !== embedded) {
          reloadForUpdate(`build ${embedded} -> ${remote}`)
        }
      })
      .catch(() => {
        // 网络/CDN 偶发失败时忽略，下轮再试
      })
      .finally(() => {
        checking = false
      })
  }

  check()
  setInterval(check, POLL_MS)
  setTimeout(() => reloadForUpdate('safety-interval'), SAFETY_RELOAD_MS)

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') check()
  })
}
